import React,{useEffect, useState, useContext} from 'react';
import { makeStyles } from '@material-ui/core/styles';
import { GlobalContext } from '../../Contexts/GlobalContext';
import Select from '@material-ui/core/Select';
import MenuItem from '@material-ui/core/MenuItem';
import InputLabel from '@material-ui/core/InputLabel';
import FormControl from '@material-ui/core/FormControl';
import useFetch from '../../CustomHooks/useFetch';
import useGuiTranslations from './useGuiTranslations';
import { capitalizeFirstLetter } from '../../Util/StringFunctions';


export default function TimeZoneSelector (props) {
    const globalContext = useContext(GlobalContext);
    const classes = useStyles();
    const [getTimeZonesHookResponse, getTimeZonesHook] = useFetch();
    const [translateGui] = useGuiTranslations();

    useEffect(
        () => {
            getTimeZonesHook(
                {
                    url: '/api/timezone',
                    addTokenHeader: false,
                    method: 'GET',
                    postData: null,
                }
            )
        }, []
    )


    return (
        <FormControl className={classes.formControl}>
        <InputLabel id="demo-simple-select-label">{capitalizeFirstLetter(translateGui(63))}</InputLabel>
        {
            getTimeZonesHookResponse.length > 0 ?
                <Select
                    labelId="demo-simple-select-label"
                    id="demo-simple-select"
                    value={props.timeZone}
                    onChange={(e)=> props.setTimeZone(e.target.value)}
                >
                    {
                        getTimeZonesHookResponse.map(
                            (tz, index) =>
                                index > 149 && index <299 ?
                                    <MenuItem key={tz.id} value={tz.id}>{tz.displayName + ' ' + tz.id}</MenuItem>
                                    : null
                        )
                    }

                </Select>
                : null
        }

    </FormControl>

    )
}

const useStyles = makeStyles({
    root: {
    }
});